import { ArrowLeft } from "lucide-react";

export function LegalLayout({ title, updated, children }) {
  return (
    <main className="min-h-screen bg-background">
      <header className="surface-navy">
        <div className="mx-auto flex h-[68px] max-w-3xl items-center justify-between px-4 sm:px-6">
          <a href="/" data-testid="legal-logo" className="inline-flex items-center gap-2.5">
            <img src="/sedio-logo.png" alt="Sedio" width={34} height={34} className="h-8 w-8 object-contain" />
            <span className="font-display text-lg font-extrabold tracking-tight text-white">Sedio</span>
          </a>
          <a href="/" className="inline-flex items-center gap-1.5 text-sm text-slate-300 hover:text-white">
            <ArrowLeft className="h-4 w-4" /> Torna al sito
          </a>
        </div>
      </header>

      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:py-16">
        <h1 className="font-display text-4xl font-extrabold tracking-tight text-foreground">{title}</h1>
        {updated && <p className="mt-2 text-sm text-muted-foreground">Ultimo aggiornamento: {updated}</p>}
        <div className="legal-content mt-8 space-y-5 text-[15px] leading-7 text-muted-foreground">{children}</div>
      </div>

      <footer className="surface-navy">
        <div className="mx-auto flex max-w-3xl flex-col items-start justify-between gap-3 px-4 py-6 text-xs text-slate-400 sm:flex-row sm:items-center sm:px-6">
          <p>© {new Date().getFullYear()} Sedio. Tutti i diritti riservati.</p>
          <div className="flex gap-6">
            <a href="/privacy" className="hover:text-white">Privacy</a>
            <a href="/termini" className="hover:text-white">Termini</a>
            <a href="/#contatti" className="hover:text-white">Contatti</a>
          </div>
        </div>
      </footer>
    </main>
  );
}

export function H2({ children }) {
  return <h2 className="pt-4 font-display text-xl font-bold text-foreground">{children}</h2>;
}
